import { render } from "./AddFicheStock.vue?vue&type=template&id=5ff72f12&ts=true"
import script from "./AddFicheStock.vue?vue&type=script&lang=ts"
export * from "./AddFicheStock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__